import React, { useEffect, useState } from "react";
import { Amplify, Auth } from "aws-amplify";
import { USER_AUTH_CONFIG } from "../aws-config";
import { Button, Typography } from "@mhome/ui";
import { useHistory, useLocation } from "react-router-dom";
import useApiCall from "../common/api-call";

const UserLink = () => {
  const history = useHistory();
  const location = useLocation();
  const { apiCall } = useApiCall();
  const [status, setStatus] = useState("");
  const [orgInfo, setOrgInfo] = useState(null);

  useEffect(() => {
    setStatus("loading");
    Amplify.configure(USER_AUTH_CONFIG);

    // Extract the 'org' query parameter from the URL
    const queryParams = new URLSearchParams(location.search);
    const orgId = queryParams.get("org");

    if (orgId) {
      fetchOrgInfo(orgId);
    } else {
      setStatus("error");
    }
  }, [location.search]);

  const fetchOrgInfo = async (orgId) => {
    const response = await apiCall(`/org/info?id=${orgId}`, "GET", null);
    if (response) {
      setOrgInfo(response);
      setStatus("loaded");
    } else {
      setStatus("error");
    }
  };

  const handleLink = () => {
    if (orgInfo) {
      history.push(orgInfo.oAuthUrl); // Redirect to the org's OAuth URL
    }
  };

  const handleLogout = async () => {
    Amplify.configure(USER_AUTH_CONFIG);
    await Auth.signOut();
    history.push("/user-login");
  };

  return (
    <>
      {status === "loaded" && (
        <div
          className="flex flex-col items-center justify-center text-center"
          style={{
            minHeight: "100vh",
            paddingLeft: "16px",
            paddingRight: "16px",
            backgroundColor: "hsl(var(--background))",
          }}
        >
          <Typography variant="h5" style={{ marginBottom: "16px" }}>
            {`Your mHome account is not linked to ${orgInfo.name}`}
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "16px" }}>
            Please choose one of the options below to proceed.
          </Typography>
          <div
            className="flex"
            style={{
              marginTop: "32px",
              gap: "16px",
            }}
          >
            <Button variant="contained" color="primary" onClick={handleLogout}>
              Switch Account
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleLink}
              disabled={!orgInfo}
            >
              Start Linking
            </Button>
          </div>
        </div>
      )}
      {status === "error" && (
        <div
          className="flex flex-col items-center justify-center text-center"
          style={{
            minHeight: "100vh",
            paddingLeft: "16px",
            paddingRight: "16px",
            backgroundColor: "hsl(var(--background))",
          }}
        >
          <Typography variant="h5" style={{ marginBottom: "16px" }}>
            Failed to access organization info.
          </Typography>
        </div>
      )}
    </>
  );
};

export default UserLink;
